import React from 'react';
import { motion } from 'framer-motion';
import { Plus } from 'lucide-react';
const extras = [{
  name: 'Engine Bay Top',
  price: '$120'
}, {
  name: 'Headlight Restore',
  price: '$80'
}, {
  name: 'Clay Bar Treatment',
  price: '$60'
}, {
  name: 'Water Spots / Dog Hair',
  price: 'Call for Pricing'
}, {
  name: 'Hybrid Ceramic Glass Treatment',
  price: '$200'
}, {
  name: 'Hybrid Ceramic Treatment — 1 Year',
  price: 'Call for Pricing'
}];
export function Extras() {
  return <section className="w-full bg-black py-16 px-4" id="extras" data-id="element-160" data-mp="ynoofgrfiznv">
      <div className="max-w-7xl mx-auto" data-id="element-161" data-mp="yp9fuxig62hi">
        <div className="relative bg-zinc-900/80 border-2 border-red-600/70 rounded-lg p-5 sm:p-8 md:p-10 lg:p-12 overflow-hidden shadow-[0_0_30px_-5px_rgba(220,38,38,0.2)]" data-id="element-162" data-mp="kooym5s6keq4">
          {/* Decorative background element */}
          <div className="absolute top-0 right-0 w-72 h-72 bg-red-600/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none" data-id="element-163" data-mp="2f39gybt13y6c" />

          <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-6 mb-8 md:mb-10" data-id="element-164" data-mp="2j1gu6woaahcs">
            <div className="text-center md:text-left" data-id="element-165" data-mp="vb5rwytv736o">
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-black uppercase text-white mb-3" data-id="element-166" data-mp="vamd3qziguwv">
                <span className="text-red-600" data-id="element-167" data-mp="19z0m6jnitflv">Extra</span> Services
              </h2>
              <p className="text-gray-400 text-base sm:text-lg md:text-xl" data-id="element-168" data-mp="1517hxw5s2vo8">
                Add these to any package for the ultimate finish
              </p>
            </div>
            <div className="p-4 bg-red-600/10 border border-red-900/50 rounded-lg" data-id="element-169" data-mp="cd3c9an7iilj">
              <Plus className="w-9 h-9 text-red-500" data-id="element-170" data-mp="r9u3gwmq8o02" />
            </div>
          </div>

          <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6" data-id="element-171" data-mp="mahf27g7j8vd">
            {extras.map((extra, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-center justify-between gap-4 p-5 md:p-6 bg-black/40 border border-zinc-700 rounded-lg hover:border-red-600/60 transition-colors" data-id="element-172" data-mp="22noegz6ot58x" data-mpi={index}>
                <span className="font-bold text-gray-200 uppercase tracking-wide text-base sm:text-xl min-w-0" data-id="element-173" data-mp="2erimc56ffu9e">
                  {extra.name}
                </span>
                <span className="font-black text-red-500 text-xl sm:text-2xl whitespace-nowrap" data-id="element-174" data-mp="1m2uz4424aut7">
                  {extra.price}
                </span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}